module.exports = __webpack_public_path__ + "img/wx-img4.3b68d6ca.png";